var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoolicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 26,
    viewBox: "0 0 32 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.125 25.6742H3.125C1.39911 25.6742 0 24.2751 0 22.5492V3.79919C0 2.0733 1.39911 0.674194 3.125 0.674194H28.125C29.8509 0.674194 31.25 2.0733 31.25 3.79919V22.5492C31.25 24.2751 29.8509 25.6742 28.125 25.6742ZM3.125 3.79919V22.5492H28.125V3.79919H3.125ZM21.0938 19.4242C18.9364 19.4242 17.1875 17.6753 17.1875 15.5179C17.1875 13.3606 18.9364 11.6117 21.0938 11.6117C23.2511 11.6117 25 13.3606 25 15.5179C25 16.5539 24.5884 17.5475 23.8559 18.2801C23.1233 19.0126 22.1298 19.4242 21.0938 19.4242ZM14.8438 19.4242C12.6864 19.4242 10.9375 17.6753 10.9375 15.5179C10.9375 13.3606 12.6864 11.6117 14.8438 11.6117C15.6919 11.6124 16.516 11.8937 17.1875 12.4117C16.2051 13.1416 15.626 14.2933 15.626 15.5172C15.626 16.741 16.2051 17.8927 17.1875 18.6226C16.5162 19.1412 15.6921 19.4231 14.8438 19.4242Z",
    fill: "#A71D22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoolicon);
export default __webpack_public_path__ + "static/media/coolicon.a9566a8f1ae15907ef93bed6ec07ce1b.svg";
export { ForwardRef as ReactComponent };